import { render, staticRenderFns } from "./BankCredits.vue?vue&type=template&id=15475eb8"
import script from "./BankCredits.vue?vue&type=script&lang=js"
export * from "./BankCredits.vue?vue&type=script&lang=js"
import style0 from "./BankCredits.vue?vue&type=style&index=0&id=15475eb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports